export const LOCATIONS_ATTENTION_QUERY = 'attention';

/** Read `?attention=1` from the Locations list search. */
export function parseLocationsAttentionFromSearch(search: string): boolean {
  const raw = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search,
  )
    .get(LOCATIONS_ATTENTION_QUERY)
    ?.trim();
  return raw === '1' || raw === 'true';
}

export function locationsNeedsAttentionHref(pathname: string): string {
  const params = new URLSearchParams();
  params.set(LOCATIONS_ATTENTION_QUERY, '1');
  return `${pathname}?${params.toString()}`;
}

export function replaceLocationsAttentionSearch(
  search: string,
  enabled: boolean,
): string {
  const params = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search,
  );
  if (enabled) {
    params.set(LOCATIONS_ATTENTION_QUERY, '1');
  } else {
    params.delete(LOCATIONS_ATTENTION_QUERY);
  }
  const next = params.toString();
  return next ? `?${next}` : '';
}
